import React from 'react'
import { useBlockingSession } from '../../Hooks/Features/Inspectra/useBlockingSession'
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid'
import { useCheckBlocking } from '../../Hooks/Features/Inspectra/useCheckBlocking'

const CheckBlocking = ({ projectChanged }) => {
    const { blockingSessionsCols, rowData, loader, leadBlockerCols, blockedSessionsCols, handleChange, getCheckBlocking, filterValue } = useCheckBlocking({ projectChanged })

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Check Blocking</div>
                <div className='d-flex gap-4'>
                    <input type='number' onChange={handleChange} placeholder='Blocking Duration Threshold' className='input-dd' name='BlockingDurationThreshold' value={filterValue?.BlockingDurationThreshold} onBlur={() => { if (filterValue?.isChange) { getCheckBlocking() } }} />
                    <input type='number' onChange={handleChange} placeholder='Blocked Session Threshold' className='input-dd' name='BlockedSessionThreshold' value={filterValue?.BlockedSessionThreshold} onBlur={() => { if (filterValue?.isChange) { getCheckBlocking() } }} />
                </div>
            </div>
            <div className="mt-2 w100" style={{ minHeight: "200px", maxHeight: "400px", overflow: "auto" }}>
                <CommonGrid columns={leadBlockerCols} data={[{ title: "", id: "all", children: rowData?.check_blocking }]} loader={loader} headerHeight={50} />
            </div>
            <div className="mt-4 w100" style={{ minHeight: "200px", maxHeight: "400px", overflow: "auto" }}>
                <CommonGrid columns={blockedSessionsCols} data={[{ title: "", id: "all", children: rowData?.check_blocking_list }]} loader={loader} headerHeight={50} />
            </div>
        </div>
    )
}

export default CheckBlocking
